// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__33nIo","notes":"Notes_notes__288iu"};